module.exports = __webpack_public_path__ + "static/media/dyk_1.5faa49ab.svg";